export const techInfoModel = {
    name: 'techInfo',
    state: {
        gridApi: {
            gridRef_drillingAndDecommissioning: null,
            gridRef_construction: null,
            gridRef_perforation: null,
            gridRef_isolation: null,
            gridRef_development: null,
            gridRef_devPerforation: null,
            gridRef_devID: null,
            gridRef_devKVU: null,
            gridRef_testing: null,
            gridRef_tryingOut: null,
            gridRef_conservation: null,
            gridRef_exploitationColumn: null,
            gridRef_externalColumnSpace: null,
            gridRef_currentBottomhole: null,
        },
    },
    reducers: {
        setGridApi(state, payload) {
            return {
                ...state,
                gridApi: {
                    ...state.gridApi,
                    [payload.tableName]: payload.tableData,
                },
            };
        },
    },
    effects: {},
};
